module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contratos/listado/modal-eliminar-contrato/modal-eliminar-contrato.component.scss
// module id = ./src/app/components/contratos/listado/modal-eliminar-contrato/modal-eliminar-contrato.component.scss
// module chunks = main